import { useState, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

import { useGetAttendanceForStudentQuery } from '@school_ify/schoolify-repository/src/student/types';

import './PeriodsTable.scss';

import i18n from 'translations/i18n';
import useSemesters from 'clean/apiHooks/useSemesters';

import StudentGradeCell from './components/StudentGradeCell/StudentGradeCell';

const PeriodsTable: React.FC = () => {
  const { semesterId } = useSemesters();

  const { data } = useGetAttendanceForStudentQuery({
    skip: !semesterId,
    variables: {
      where: {
        semester_id: {
          _eq: semesterId,
        },
      },
    },
  });

  const attendenceItems = data?.attendances || [];

  const subjects: { id: string; name: string }[] = [];
  attendenceItems.forEach(item => {
    const id = item?.subject?.id;
    if (!subjects.find(item => item.id === id) && id !== undefined) {
      subjects.push({ id, name: item?.subject?.title });
    }
  });

  const dateItems: {
    date: string;
    subjects: { subjectId: string; ids: string[] }[];
    cellCount: number;
  }[] = [];

  const itemsSorted = attendenceItems.slice().sort((a: any, b: any) => {
    return DateTime.fromISO(a.date).toUnixInteger() - DateTime.fromISO(b.date).toUnixInteger();
  });

  itemsSorted.forEach(item => {
    const date = DateTime.fromISO(item.date).toFormat('y-MM-dd');

    if (!dateItems.find(subjectDate => subjectDate.date === date)) {
      dateItems.push({ date, subjects: [], cellCount: 0 });
    }
  });

  attendenceItems.forEach(item => {
    const date = DateTime.fromISO(item.date).toFormat('y-MM-dd');
    const subjectDate = dateItems.find(i => i.date === date);
    const subjectId = item?.subject?.id;

    const existingItem = subjectDate.subjects.find(subject => subject.subjectId === subjectId);

    if (existingItem) {
      existingItem.ids.push(item.id);
    } else {
      subjectDate.subjects.push({ ids: [item.id], subjectId });
    }
  });
  dateItems.forEach(dateItem => {
    const maxCellsPerDate = Math.max(...dateItem.subjects.map(subject => subject.ids.length));
    dateItem.cellCount = maxCellsPerDate;
  });

  const [popoverOpened, setPopoverOpened] = useState('');

  const scrollContainer = useRef(null);
  const { t } = useTranslation();

  const handleTableScroll = () => {
    if (popoverOpened !== '') {
      setPopoverOpened('');
    }
  };

  // if (false) {
  //   return null;
  // }

  return (
    <div className="student-attendance-periods">
      <div className="subject-title">{}</div>
      {subjects.length ? (
        <div ref={scrollContainer} onScroll={handleTableScroll} className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th></th>
                {dateItems.map(dateItem => {
                  const arr = Array(dateItem.cellCount).fill(1);
                  return arr.map((dateItemId, index) => {
                    return (
                      <th key={index}>
                        <div>
                          {DateTime.fromISO(dateItem.date)
                            .setLocale(i18n.language)
                            .toFormat('dd.MM')}
                        </div>
                      </th>
                    );
                  });
                })}
              </tr>
            </thead>

            <tbody>
              {subjects.map(subject => {
                return (
                  <tr key={subject.id}>
                    <td>{subject.name}</td>
                    {dateItems.map(dateItem => {
                      const dateItemSubject = dateItem.subjects.find(
                        item => item.subjectId === subject.id
                      );

                      const arr = Array(dateItem.cellCount).fill(1);
                      return arr.map((id2, index) => {
                        const id = (dateItemSubject?.ids || [])[index];
                        if (!id) {
                          return <td key={index}></td>;
                        }
                        const gradeItem = attendenceItems.find(i => i.id === id);

                        return (
                          <StudentGradeCell
                            id={id}
                            key={id}
                            gradeItem={gradeItem}
                            popoverOpened={popoverOpened}
                            setPopoverOpened={setPopoverOpened}
                          />
                        );
                      });
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="assignments-missing">{t('attendance:noItemsFound')}</div>
      )}
    </div>
  );
};

export default PeriodsTable;
